import React from 'react';
import '../less';
import {Control, Link} from 'MWC';
import {LANG} from '../../../services/l10n';
import moment from 'moment';
import 'moment/locale/uk'
import more_icon from '../img/more_icon.svg'
import banner_img from '../img/banner_img.png'
import { Preloader } from 'MWComponents';

export default function template() {
    const  {
            news,
            total,
            showModal,
        } = this.state,
        isMobile = this.isViewportMobile(),
        isUa = this.props.lang === LANG.UA,
        title = isUa ? 'title_ua' : 'title_ru',
        preview = 'preview_ua',
        newsList = news.map(article => {

            return (
                <div key={article.id} className="article">
                    <div className="left-part">
                        <img className="article-img" src={this.changeFilesUrl(article[preview])} alt="article preview" />
                    </div>
                  <div className="right-part">
                    <div className="article-date">
                      {moment(article.date).locale('uk').format("DD MMMM yyyy")} {this.l10n('YYYY')}
                    </div>
                    <div className="article-title__wrapper">
                      <h3 className="article-title">{article[title]}</h3>
                    </div>
                    <Link href={`/news/${article.id}`} className="sorting-btn more-info">
                      {this.l10n('NEWS_READ')}
                    </Link>
                  </div>
                </div>
            );
        });

  return (
    <section className="module-news">
      <div className="content">
        <Control className="news-banner">
          <div className="left-side">
            <h1>{this.l10n('NEWS_HEADING')}</h1>
            <div>{this.l10n('NEWS_SUBHEADING')}</div>
          </div>
          <img src={banner_img} alt="banner_img" />
        </Control>
        <h2 className="title">{this.l10n('NEWS_TAG_ALL')}</h2>
        <div className="news-list">{news.length ? newsList : <Preloader />}</div>
          <button
              style={!news.length ? {display: 'none'} : {}}
              className={`btn-success show-more`}
              disabled={news.length >= total}
              onClick={this.addNews}
          >
              {this.l10n('NEWS_SHOW_MORE')}
            <img ref={this.myRef} src={more_icon} alt="more_icon"/>
          </button>
      </div>
    </section>
    );
}
